import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // View actions
  signIn: ['token', 'refreshToken', 'rol'],
  // Reducer
  signInRequest: null,
  signInSuccess: null,
  signInFailure: ['error'],
  signOutRequest: null,
  signOutSuccess: null,
  signOutFailure: ['error']
});

export { Creators, Types };
